<script lang="ts" setup>
import { useVoipRoomStore } from '@stores/voip-room'

import LiveKitButtonMic from '@Widgets/Classroom/LiveKit/LiveKitButtonMic.vue'

defineOptions({
  name: 'ButtonMic',
})

const voipRoomStore = useVoipRoomStore()
</script>

<template>
  <LiveKitButtonMic
    v-if="voipRoomStore.isLiveKitRoom"
  />
</template>
